import { defineComponent, openBlock, createBlock, unref, withCtx, createTextVNode } from 'vue';
import { EditorService } from '@ssml-editor/core';
import { Button } from '@ssml-editor/vue';
import { ElMessage } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                               */
/* empty css                                                                                                                                                 */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "save-menu",
  props: {
    config: {},
    editor: {}
  },
  setup(__props) {
    const editorService = __props.config ? new EditorService(__props.config.databaseName, __props.config.html) : void 0;
    async function saveHandler() {
      try {
        if (__props.editor && editorService && await editorService.saveHtml(__props.editor.html)) {
          ElMessage.success({ message: "保存成功!", grouping: true });
        } else {
          ElMessage.error({ message: "保存失败!", grouping: true });
        }
      } catch (error) {
        ElMessage.error({ message: "保存失败!", grouping: true });
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Button), {
        "icon-class": "iconfont-ssml-editor icon-ssml-editor-baocun",
        onClick: saveHandler
      }, {
        default: withCtx(() => [
          createTextVNode("保存")
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=save-menu.vue.js.map
